import { Button, Drawer, Space } from "antd";
import { X } from "lucide-react";
import Moment from "react-moment";
import { formatNumber } from "../../../utils/formatNumber";

export default function BookingDetails({
  setVisible,
  isVisible,
  selected,
}: any) {
  return (
    <Drawer
      title="BOOKING DETAILS"
      placement={"right"}
      width={800}
      onClose={() => setVisible(!isVisible)}
      open={isVisible}
      closable={false}
      extra={
        <Space className="flex justify-center items-center">
          <Button
            type="default"
            onClick={() => setVisible(!isVisible)}
            danger
          >
            <X size={16} />
          </Button>
        </Space>
      }
    >
      <div className="flex flex-col">
        <div className="flex text-black font-bold text-lg mb-4">
          VEHICLE:
          <span className="ml-2">

            {selected?.title ? selected?.title : selected?.registration}
          </span>
        </div>
        <div className="flex">
          <div className="flex">
            <div>
              <div className="mb-4">
                <span className="mt-2 text-black font-bold">
                  Customer Details:{" "}
                </span>
                <div className="flex">
                  <div className="flex flex-col ml-2">
                    <span>- Name: {selected?.name}</span>
                    <span>- Mobile: {selected?.mobile}</span>
                    <span>- Email: {selected?.email}</span>
                    <span>- Address: {selected?.address}</span>
                    <span>- Account: {selected?.customerId || "-"}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="mx-2">
            <div className="flex text-black font-bold text-sm">
              Vehicle Details : -
            </div>

            <div className="ml-2">
              <span className="">- Make : </span>
              {selected?.vehicleMake}
            </div>

            <div className="ml-2">
              <span className="">- Model : </span>
              {selected?.vehicleModel}
            </div>
            <div className="ml-2">
              <span className="">- VIN : </span>
              {selected?.vin}
            </div>
            <div className="ml-2">
              <span className="">- Engine No : </span>
              {selected?.engine}
            </div>
            <div className="ml-2">
              <span className="">- Mileage : </span>
              <span className="text-gray-700">
                {selected?.mileage === null || selected?.mileage === ""
                  ? "-"
                  : formatNumber(Number(selected?.mileage))}{" "}
                Km
              </span>
            </div>
          </div>
          <div className="mx-2">
            <div className="flex text-black font-bold text-sm">
              Booking Details : -
            </div>
            <div className="ml-2">
              <span className="">- Requested : </span>
              <Moment format="Do MMM, YYYY">{selected?.createdAt}</Moment>
            </div>
            <div className="flex ml-2">
              <span className="w-16">- Center : </span>
              {selected?.site?.name}
            </div>
            <div className="flex ml-2">
              <span className="w-16">- Date: </span>
              <Moment format="Do MMM, YYYY">{selected?.date}</Moment>
            </div>
            <div className="flex ml-2">
              <span className="w-20">- Time : </span>
              <Moment format="HH:mm A">{selected?.startTime}</Moment>
              <div className="mx-2">-</div>
              <Moment format="HH:mm A">{selected?.endTime}</Moment>
            </div>
            <div className="flex ml-2">
              <div className="w-24">- Booking No : </div>
              {selected?.bookingNo}
            </div>
            <div className="flex ml-2">
              <span className="w-16">- WIP : </span>
              {selected?.wip}
            </div>
          </div>
        </div>
        <div className="">
          <div className="font-bold">Services : </div>
          <div className="">
            {selected?.services?.map((service: any, index: number) => (
              <div className="ml-2 flex" key={service.id}>
                <div className="text-gray-700 mx-2"> {index + 1}.</div>
                <div className="">

                  {service.name}
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="flex flex-col mt-2">
          <span className="italic font-semibold"> Additional Remarks : </span>
          {selected?.comments ? (
            <div>{selected?.comments}</div>
          ) : (
            <div className="text-gray-500 py-2"> No Remarks</div>
          )}
        </div>

        <div className="mt-4">
          <div className="font-bold mb-2">Registartion Card </div>
          {selected?.attachment ? (
            <div className="border p-1">
              <img src={`data:${selected?.attachment}`} alt="" />
            </div>
          ) : (
            <span className="text-gray-50 py-2">No Document</span>
          )}
        </div>

        <div className="border-t pt-4">

        </div>
      </div>

    </Drawer>
  );
}
